import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import "./Order-history.css";
import "../../assets/css/modal.css";
import { Accordion, Card, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { MyOrders, Reorder } from "../../actions/productActions";
import { orderHistory } from "../../actions/pageAction";
import search from "../../assets/svgs/search.svg";
import Pagination from "rc-pagination";
import axios from "axios";
import OrderLoader from "../../common/OrderLoader";


const OrderHistory = (props) => {
  const [load, setLoad] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const [aclass, setAclass] = useState(null);
  const [rorder, setRorder] = useState(-1);
  const pageSize = 10;
  const { id } = useParams();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const isFetchingRef = useRef(false);

  let GetFormattedDate = (date) => {
    var newdate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    return newdate;
  }

  let GetFormattedTime = (date) => {
    var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var newtime = hour + ':' + minute;
    return newtime;
  }
  function useDebounce(value, delay = 600) {
    const [debouncedValue, setDebouncedValue] = React.useState(value);

    React.useEffect(() => {
      const handler = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
  }
  const debouncedSearch = useDebounce(searchValue, 600);

  // Reset when search changes
  useEffect(() => {
    setAclass(null);
    setPage(1);
    setHasMore(true);

    // Scroll to top when new search happens
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [debouncedSearch]);

  //Call API on page/search change
  useEffect(() => {
    isFetchingRef.current = true;
    props.orderHistory(page, pageSize, debouncedSearch || "");
  }, [page, debouncedSearch]);

  // Update UI data
  useEffect(() => {
    if (!props.loader && props.order_history) {
      const newData = props.order_history || [];

      if (page === 1) {
        setOrderHistoryData(newData);
        if (newData.length > 0) {
          setAclass(parseInt(newData[0].id));
        }

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
      else {
        setOrderHistoryData((prev) => {
          const existingIds = new Set(prev.map(p => p.id));
          const uniqueNew = newData.filter(n => !existingIds.has(n.id));
          return [...prev, ...uniqueNew];
        });
      }

      setHasMore(newData.length === pageSize);
      isFetchingRef.current = false;
    }
  }, [props.order_history, props.loader]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value.trim());
    //      const value = e.target.value.trim();
    //  setSearchValue(value);

    //  if (debounceRef.current) clearTimeout(debounceRef.current);

    //  debounceRef.current = setTimeout(() => {
    //    if (value === "") {
    //      setIsSearching(false);
    //      setPage(1);
    //    } else {
    //      setIsSearching(true);
    //      setPage(1);
    //    }
    //  }, 600);
  };

  const variationRender = (variation) => {
    if (!variation || !variation.length) return null;
    return variation.map((v, i) => (
      <span key={i} className="oh-variation-chip">
        {v.name}
      </span>
    ));
  };

  let RenderCart = (cart) => {
    if (!cart || !cart.length) return null;
    return cart.map((item, key) => (
      <tr key={key} className="oh-item-row">
        <td className="oh-item-qty">{item.quantity} x</td>
        <td className="oh-item-name">
          {item.name}
          <div>{variationRender(item.adons)}</div>
        </td>
        <td className="oh-item-price">${parseFloat(item.total_for_single_item).toFixed(2)}</td>
      </tr>
    ));
  };

  const handleSelect = (idx) => {
    const key = idx !== null ? parseInt(idx) : null;
    setAclass((prev) => (prev === key ? null : key));
  };

  let RenderOrders = () => {
    if (!orderHistoryData || !orderHistoryData.length) return null;

    return orderHistoryData.map((key) => {
      const inkey = parseInt(key.id);
      const t = key.transaction_date?.split(/[- :]/);
      const cdate = t ? new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]) : null;
      const adate = key.d_date ? new Date(key.d_date) : null;

      return (

        <Card key={inkey}>
          <Accordion.Toggle
            as={Button}
            className={`oh-header-toggle ${aclass === inkey ? "" : "collapsed"}`}
            variant="light"
            eventKey={inkey}
          >
            <div className="oh-header-left">
              <span className="invoice-number">Invoice Number: {key.invoice_no}</span>
              <span className="order-date">
                {cdate != null ? `${GetFormattedDate(cdate)}  ${GetFormattedTime(cdate)}` : ""}
              </span>
            </div>

            <div className="oh-header-right">
              {key.refund_all && <span className="void-badge">Void</span>}
              <span className="delivery-badge">
                {key.type_for_api === "Delivery" ? "DELIVERY" : "PICKUP"}
              </span>
              <i className="fa fa-caret-down"></i>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey={inkey}>
            <Card.Body>
              <div className="row">
                {/* Product List / Table Section */}
                <div className="col-md-6">
                  <table className="oh-items-table">
                    <tbody>{RenderCart(key.item)}</tbody>
                  </table>

                  <div className="oh-totals-wrapper">
                    {/* Delivery Charge */}
                    {key.type_for_api === "Delivery" && Number(key.delivery_charge) > 0 && (
                      <div className="oh-total-row">
                        <span className="oh-total-label">Delivery Charge:</span>
                        <span className="oh-total-value">${Number(key.delivery_charge).toFixed(2)}</span>
                      </div>
                    )}

                    {/* Small Order Charge */}
                    {Number(key.small_order_fee) > 0 && (
                      <div className="oh-total-row">
                        <span className="oh-total-label">Small Order Charge:</span>
                        <span className="oh-total-value">${Number(key.small_order_fee).toFixed(2)}</span>
                      </div>
                    )}

                    {/* Discount */}
                    {Number(key.discount_amount) > 0 && (
                      <div className="oh-total-row">
                        <span className="oh-total-label">Discount Amount:</span>
                        <span className="oh-total-value">-${Number(key.discount_amount).toFixed(2)}</span>
                      </div>
                    )}

                    {/* Tax / GST */}
                    {Number(key.tax_amount) > 0 && (
                      <div className="oh-total-row">
                        <span className="oh-total-label">GST:</span>
                        <span className="oh-total-value">${Number(key.tax_amount).toFixed(2)}</span>
                      </div>
                    )}

                    {/* Round Off */}
                    {Number(key.round_off_amount) > 0 && (
                      <div className="oh-total-row">
                        <span className="oh-total-label">Round Off:</span>
                        <span className="oh-total-value">
                          -${Number(key.round_off_amount).toFixed(2)}
                        </span>
                      </div>
                    )}

                    {/* Grand Total */}
                    <div className="oh-total-row oh-grand-total">
                      <span className="oh-total-label">Total:</span>
                      <span className="oh-total-value">${Number(key.total || 0).toFixed(2)}</span>
                    </div>
                  </div>
                </div>

                {/* Information / Details Section */}
                <div className="col-md-6">
                  {/* Address */}
                  <div className="oh-info-group">
                    <label className="oh-info-label">
                      <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      {key.type_for_api === "Delivery" ? "Deliver to" : "Pick up from"}
                    </label>
                    <span className="oh-info-value">
                      {key?.type_for_api === "Delivery" ? key?.d_address : key.business_location_name_for_pickup}
                    </span>
                  </div>

                  {/* Invoice Secondary */}
                  <div className="oh-info-group">
                    <label className="oh-info-label">
                      <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Invoice Number
                    </label>
                    <span className="oh-info-value">{key?.invoice_no}</span>
                  </div>

                  {/* Timing Section */}
                  {key.type_for_api === "Delivery" ? (
                    <div style={{ display: "flex", gap: "24px" }}>
                      <div className="oh-info-group" style={{ flex: 1 }}>
                        <label className="oh-info-label">
                          <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Estimated Arrival
                        </label>
                        <span className="oh-info-value muted">
                          {key?.estimated_arrival_time}
                        </span>
                      </div>
                      <div className="oh-info-group" style={{ flex: 1 }}>
                        <label className="oh-info-label">
                          <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Arrived
                        </label>
                        <span className="oh-info-value">
                          {key?.updated_at?.split(" ")[1]}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="oh-info-group">
                      <label className="oh-info-label">
                        <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Pickup time
                      </label>
                      <span className="oh-info-value">
                        {key.d_time && key.d_time}
                      </span>
                    </div>
                  )}

                  {/* Payment & Status */}
                  <div style={{ display: "flex", gap: "24px" }}>
                    <div className="oh-info-group" style={{ flex: 1 }}>
                      <label className="oh-info-label">
                        <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                        Payment Method
                      </label>
                      <span className="oh-info-value">
                        {key.paymentType === "cash" || key.paymentType === "paynow"
                          ? key.paymentType.toUpperCase()
                          : `${key.card_type?.toUpperCase() || ""} •••• ${key.last_4_card_digits || ""}`}
                      </span>
                    </div>

                    {key.type_for_api === "Delivery" && (
                      <div className="oh-info-group" style={{ flex: 1 }}>
                        <label className="oh-info-label">
                          <svg className="oh-info-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0zM13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1" />
                          </svg>
                          Delivery Status
                        </label>
                        <span className={`status-badge ${key?.lalamove_status === "EXPIRED" ? "status-expired" : "status-success"}`}>
                          {key?.lalamove_status}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      );
      // if (id) {
      //   if (parseInt(id) === inkey) html.push(htmltemp);
      // } else {
      //   html.push(htmltemp);
      // }
    });
    //     }
    // return html;
  };

  //Infinite Scroll
  useEffect(() => {
    const handleScroll = () => {
      if (!hasMore || isFetchingRef.current) return;
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 200) {
        isFetchingRef.current = true;
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore]);

  return (
    <>
      <div className="search-bar-section">
        <div className="search-bar-layout">
          <input
            type="text"
            className="search-input"
            placeholder="Search invoice..."
            value={searchValue}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <div className="main_section" style={{ position: "relative" }}>

        {/* Wrap Orders + Bottom Loader in One Clean Container */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "70vh",
            justifyContent: "space-between"
          }}
        >
          <div className="order-gutter ispd" style={{ width: "100%" }}>

            {props.loader && page === 1 ? (
              <div
                style={{
                  height: "70vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <OrderLoader text="" color="#ff0000" size={60} />
              </div>
            ) : orderHistoryData && orderHistoryData.length > 0 ? (
              <Accordion activeKey={aclass} onSelect={handleSelect}>
                {RenderOrders()}
              </Accordion>
            ) : (
              //When no orders are shown, the footer overlaps and hides the options (Account, Track Order, Order History, Sign Out). Setting the container height to 70vh resolves this issue.
              <div style={{ height: "70vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%" }}>
                <div style={{ width: "110px", height: "110px", borderRadius: "50%", backgroundColor: "#FFF0F0", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "24px" }}>
                  <svg width="52" height="52" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 2v7c0 1.1.9 2 2 2h2a2 2 0 002-2V2" stroke="#e01e26" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <line x1="7" y1="2" x2="7" y2="22" stroke="#e01e26" strokeWidth="1.8" strokeLinecap="round" />
                    <path d="M21 15V2a5 5 0 00-5 5v6h3v7" stroke="#e01e26" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h4 style={{ color: "#1a1a1a", fontWeight: 700, fontSize: "20px", margin: "0 0 8px 0" }}>No Orders Placed Yet</h4>
                <p style={{ color: "#C0C0C0", fontSize: "14px", lineHeight: "1.8", margin: 0, textAlign: "center" }}>
                  You haven't placed any orders yet.<br />Your order history will appear here.
                </p>
              </div>
            )}
          </div>

          {hasMore ? (
            props.loader && page > 1 ? (

              <div
                style={{
                  marginBottom: "10px",
                  padding: 0,
                  lineHeight: 0,
                  height: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <OrderLoader text="" color="#ff0000" size={60} />
              </div>

            ) : null
          ) : (
            <div
              style={{
                textAlign: "center",
                marginBottom: "25px",
                color: "#999",
                fontSize: "13px",
                letterSpacing: "1px"
              }}
            >
            </div>
          )
          }

        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  orders: state.products.orders,
  reorders: state.products.reorders,
  loading: state.products.loading,
  order_history: state.page.order_history,
  total_orders: state.products.total_orders,
  loader: state.products.loader
});

export default withTranslation()(
  connect(mapStateToProps, { MyOrders, Reorder, orderHistory })(OrderHistory)
);